export function checkSearchQueryEmpty(query: {}) {
  return Object.keys(query).filter(key => key !== 'page').length === 0;
}
